import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import { faGlobaleaks } from '@fortawesome/free-brands-svg-icons';

// disable auto CSS injection
config.autoAddCss = false;
config.autoReplaceSvg = 'nest';

// Collect the icons you actually want
const icons = [
  solidIcons.faArrowLeft,
  solidIcons.faArrowsRotate,
  solidIcons.faAsterisk,
  solidIcons.faBackward,
  solidIcons.faBackwardFast,
  solidIcons.faBackwardStep,
  solidIcons.faBan,
  solidIcons.faBars,
  solidIcons.faBarsProgress,
  solidIcons.faBell,
  solidIcons.faBellSlash,
  solidIcons.faBolt,
  solidIcons.faCalendar,
  solidIcons.faCaretDown,
  solidIcons.faCaretUp,
  solidIcons.faChartPie,
  solidIcons.faCheck,
  solidIcons.faChevronDown,
  solidIcons.faChevronLeft,
  solidIcons.faChevronRight,
  solidIcons.faChevronUp,
  solidIcons.faCircleArrowLeft,
  solidIcons.faCircleArrowRight,
  solidIcons.faCircleDot,
  solidIcons.faCircleExclamation,
  solidIcons.faCircleInfo,
  solidIcons.faCircleQuestion,
  solidIcons.faCircleXmark,
  solidIcons.faClipboardList,
  solidIcons.faClock,
  solidIcons.faClone,
  solidIcons.faComment,
  solidIcons.faCopy,
  solidIcons.faDownload,
  solidIcons.faEnvelope,
  solidIcons.faEnvelopeCircleCheck,
  solidIcons.faEraser,
  solidIcons.faEye,
  solidIcons.faEyeSlash,
  solidIcons.faFile,
  solidIcons.faFilePen,
  solidIcons.faFileExport,
  solidIcons.faFilter,
  solidIcons.faFloppyDisk,
  solidIcons.faForward,
  solidIcons.faForwardFast,
  solidIcons.faForwardStep,
  solidIcons.faGear,
  solidIcons.faHashtag,
  solidIcons.faHourglass,
  solidIcons.faHouse,
  solidIcons.faInbox,
  solidIcons.faLifeRing,
  solidIcons.faLock,
  solidIcons.faMagnifyingGlass,
  solidIcons.faMicrophone,
  solidIcons.faMinus,
  solidIcons.faNetworkWired,
  solidIcons.faPenToSquare,
  solidIcons.faPeopleArrows,
  solidIcons.faPlay,
  solidIcons.faPlus,
  solidIcons.faPrint,
  solidIcons.faRankingStar,
  solidIcons.faRightFromBracket,
  solidIcons.faRightToBracket,
  solidIcons.faSitemap,
  solidIcons.faSliders,
  solidIcons.faSort,
  solidIcons.faSortDown,
  solidIcons.faSortUp,
  solidIcons.faSquare,
  solidIcons.faSquareCheck,
  solidIcons.faStar,
  solidIcons.faStop,
  solidIcons.faTag,
  solidIcons.faTrash,
  solidIcons.faUpload,
  solidIcons.faUser,
  solidIcons.faUserMinus,
  solidIcons.faUserPlus,
  solidIcons.faUsers,
  solidIcons.faVolumeLow,
  solidIcons.faVolumeXmark,
  solidIcons.faXmark,
  faGlobaleaks,
];

// Register them all at once
library.add(...icons);

dom.watch();
